import { ChangeEvent, useState } from 'react';

import { InputField } from '@/components';
import { Svg } from '@/types/editProfile';

type shieldTextInputProps = {
  initialText: string;
  values?: Svg;
  handleCustomizationValuesChange: (values: Svg) => void;
};

const ShieldTextInput = ({
  values,
  initialText,
  handleCustomizationValuesChange,
}: shieldTextInputProps) => {
  const [text, setText] = useState<string>(initialText);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let updatedValues = { ...values };
    const newText = event.target.value;
    setText(newText);
    updatedValues = {
      ...values,
      escudo: { ...values?.escudo, escudoparam5: newText },
    };
    handleCustomizationValuesChange(updatedValues);
  };

  return (
    <div className="py-4">
      <p className="font-bold">Siglas</p>
      <p className="text-xs pt-2">
        Tipeá las siglas o palabra que va en tu escudo.
      </p>
      <div className="py-2">
        <InputField
          behavior="default"
          maxLength={5}
          name="siglas"
          placeholder="Ingresar"
          value={text}
          onChange={handleChange}
        />
      </div>
      <p className="font-bold text-gdt-gray-4 ">Máximo 5 caracteres</p>
    </div>
  );
};

export default ShieldTextInput;
